module.exports = __webpack_public_path__ + "img/p-28.1c55838e.jpg";